var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDollarSquare = function SvgDollarSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.112 7.59c-.624 0-1.19.542-1.19 1.28 0 .503.108.732.204.855.102.13.275.247.614.367l4.032 1.4c.45.16.937.399 1.296.858.367.467.524 1.063.524 1.78 0 1.502-1.174 2.78-2.69 2.78h-2.51c-1.678 0-2.97-1.41-2.97-3.08a.75.75 0 0 1 1.5 0c0 .91.688 1.58 1.47 1.58h2.51c.624 0 1.19-.542 1.19-1.28 0-.503-.108-.733-.204-.855-.103-.13-.275-.247-.614-.367L9.24 11.507c-.449-.16-.936-.398-1.296-.857-.366-.468-.523-1.063-.523-1.78 0-1.502 1.174-2.78 2.69-2.78h2.51c1.678 0 2.97 1.41 2.97 3.08a.75.75 0 0 1-1.5 0c0-.91-.688-1.58-1.47-1.58h-2.51Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.75a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-1.5 0v-12a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.655 3.655C2.74 4.571 2.25 6.074 2.25 8.5v6c0 2.426.49 3.93 1.405 4.845.916.915 2.419 1.405 4.845 1.405h6c2.426 0 3.93-.49 4.845-1.405.915-.916 1.405-2.419 1.405-4.845v-6c0-2.426-.49-3.93-1.405-4.845-.916-.915-2.419-1.405-4.845-1.405h-6c-2.426 0-3.93.49-4.845 1.405Zm-1.06-1.06C3.929 1.26 5.926.75 8.5.75h6c2.574 0 4.57.51 5.905 1.845C21.74 3.929 22.25 5.926 22.25 8.5v6c0 2.574-.51 4.57-1.845 5.905-1.334 1.335-3.331 1.845-5.905 1.845h-6c-2.574 0-4.57-.51-5.905-1.845C1.26 19.071.75 17.074.75 14.5v-6c0-2.574.51-4.57 1.845-5.905Z",
    fill: "currentColor"
  })));
};
export default SvgDollarSquare;